import { Suspense, lazy } from "react";
import { type RouteObject } from "react-router";

import type { DashboardSchedulesDetailsQuery } from "@app_schema";

import type { Breadcrumb } from "@application/types/breadcrumb";

import { DASHBOARD_SCHEDULES_DETAILS_LOADER } from "@application/loaders/dashboard_schedules_details_loader";
import { DASHBOARD_SCHEDULES_FORM_LOADER } from "@application/loaders/dashboard_schedules_form_loader";
import { DASHBOARD_SCHEDULES_LIST_LOADER } from "@application/loaders/dashboard_schedules_list_loader";

import { DASHBOARD_SCHEDULES_LINK } from "@application/navigation/dashboard_schedules_link";

import { Loader } from "@styled/loader";

const DashboardSchedulesDetails = lazy(() =>
  import("./schedules_details").then((m) => ({
    default: m.DashboardSchedulesDetails,
  })),
);
const DashboardSchedulesEdit = lazy(() =>
  import("./schedules_edit").then((m) => ({
    default: m.DashboardSchedulesEdit,
  })),
);
const DashboardSchedulesList = lazy(() =>
  import("./schedules_list").then((m) => ({
    default: m.DashboardSchedulesList,
  })),
);
const DashboardSchedulesNew = lazy(() =>
  import("./schedules_new").then((m) => ({ default: m.DashboardSchedulesNew })),
);

export const DASHBOARD_TRIGGERS_SCHEDULES_ROUTE = {
  path: "schedules",
  handle: DASHBOARD_SCHEDULES_LINK,
  children: [
    {
      index: true,
      element: (
        <Suspense fallback={<Loader />}>
          <DashboardSchedulesList />
        </Suspense>
      ),
      loader: DASHBOARD_SCHEDULES_LIST_LOADER,
    },
    {
      path: "new",
      element: (
        <Suspense fallback={<Loader />}>
          <DashboardSchedulesNew />
        </Suspense>
      ),
      handle: {
        name: "New",
        to: "/dashboard/triggers/schedules/new",
        loader: DASHBOARD_SCHEDULES_FORM_LOADER,
      },
    },
    {
      path: ":id",
      loader: DASHBOARD_SCHEDULES_DETAILS_LOADER,
      handle: (data: DashboardSchedulesDetailsQuery): Breadcrumb => ({
        name: data.schedule.description,
        to: `/dashboard/triggers/mailboxes/${data.schedule.id}`,
      }),
      children: [
        {
          index: true,
          element: (
            <Suspense fallback={<Loader />}>
              <DashboardSchedulesDetails />
            </Suspense>
          ),
        },
        {
          path: "edit",
          element: (
            <Suspense fallback={<Loader />}>
              <DashboardSchedulesEdit />
            </Suspense>
          ),
          handle: { name: "Edit" },
          loader: DASHBOARD_SCHEDULES_FORM_LOADER,
        },
      ],
    },
  ],
} satisfies RouteObject;
